import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import shape1 from "../../images/shape/circle-shape1.png"
import ReactMarkdown from "react-markdown";

const query = graphql`
  {
    strapiAboutUs {
      subTitle
      title
      shortDescription {
        data {
          shortDescription
        }
      }
      featuresList {
        id
        icon {
          url
          alternativeText
        }
        title
        shortText
      }
    }
  }
`

const AboutUsContent = () => {
  const data = useStaticQuery(query)
  // console.log(data)
  const {
    strapiAboutUs: {
      subTitle,
      title,
      shortDescription,
      featuresList = null
    },
  } = data

  return (
    <>
      <section className="about-area ptb-100">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12 col-md-12">
              <div className="about-content">
                <div className="content d-flex flex-column">
                  <span className="sub-title">
                      
                    {subTitle}
                  </span>
                  <h2>{title}</h2>
                  <div>
                    <ReactMarkdown>{shortDescription.data.shortDescription}</ReactMarkdown>
                  </div>

                  {featuresList && (
                    <ul className="features-list">
                      {featuresList.map(feature => (
                        <li key={feature.id}>
                          <img
                            src={feature.icon.url}
                            alt={feature.icon.alternativeText}
                          />
                          <h3>{feature.title}</h3>
                          <p>{feature.shortText}</p>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/*{aboutHistoryList && (*/}
        {/*  <div className="container">*/}
        {/*    <div className="about-inner-area">*/}
        {/*      <div className="row justify-content-center align-items-center">*/}
        {/*        {aboutHistoryList.map(history => (*/}
        {/*          <div className="col-lg-4 col-md-6 col-sm-6" key={history.id}>*/}
        {/*            <div className="about-text d-flex">*/}
        {/*              <h3 style={{alignSelf: 'center'}}>{history.title}</h3>*/}
        {/*              <p>{history.shortDescription}</p>*/}

        {/*              <ul className="features-list">*/}
        {/*                {history.goalList.map(goal => (*/}
        {/*                  <li key={goal.id}>*/}
        {/*                    <i className="flaticon-tick"></i> {goal.text}*/}
        {/*                  </li>*/}
        {/*                ))}*/}
        {/*              </ul>*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*        ))}*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*)}*/}
      </section>
    </>
  )
}

export default AboutUsContent
